import { render, staticRenderFns } from "./GroupTypesList.vue?vue&type=template&id=ab9a13ba&scoped=true&"
import script from "./GroupTypesList.vue?vue&type=script&lang=js&"
export * from "./GroupTypesList.vue?vue&type=script&lang=js&"
import style0 from "./GroupTypesList.vue?vue&type=style&index=0&id=ab9a13ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9a13ba",
  null
  
)

export default component.exports